module.exports = __webpack_public_path__ + "img/en.c9e6b828.svg";